export default __webpack_public_path__ + "static/media/star.d56a6804.svg";